'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var PROP_TYPES = Object.freeze({
  PRIMITIVE: 'primitive',
  FUNCTION: 'function'
});
var PROP_TYPES_INFO = Object.freeze({
  any: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'any'
    }
  },
  array: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'array'
    }
  },
  bool: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'boolean'
    }
  },
  func: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'function'
    }
  },
  number: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'number'
    }
  },
  object: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'object'
    }
  },
  string: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'string'
    }
  },
  symbol: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'symbol'
    }
  },
  node: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'node'
    }
  },
  element: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'element'
    }
  },
  elementType: {
    type: PROP_TYPES.PRIMITIVE,
    info: {
      type: 'elementType'
    }
  },
  instanceOf: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'instanceOf'
    }
  },
  oneOf: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'oneOf'
    }
  },
  oneOfType: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'oneOfType'
    }
  },
  arrayOf: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'arrayOf'
    }
  },
  objectOf: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'objectOf'
    }
  },
  shape: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'shape'
    }
  },
  exact: {
    type: PROP_TYPES.FUNCTION,
    info: {
      type: 'exact'
    }
  },
  custom: {
    type: PROP_TYPES.FUNCTION,
    isCustom: true,
    info: {
      type: 'custom'
    }
  }
});
var defaultObj = {
  PROP_TYPES_INFO: PROP_TYPES_INFO,
  PROP_TYPES: PROP_TYPES
};

exports.PROP_TYPES = PROP_TYPES;
exports.PROP_TYPES_INFO = PROP_TYPES_INFO;
exports["default"] = defaultObj;
